<template>
  <div id="user-edit-tab-info">
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-4">
          <label class="vs-input--label">Status</label>
          <v-select
            v-model="status"
            :clearable="false"
            :options="statusOptions"
            name="status"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>

        <div class="mt-4">
          <label class="vs-input--label">Role</label>
          <v-select
            v-model="role"
            :clearable="false"
            :options="roleOptions"
            name="role"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>

        <vs-input
          class="w-full mt-4"
          label="Name"
          v-model="user.name"
          name="name"
        />

        <vs-input
          class="w-full mt-4"
          label="Email"
          readonly
          v-model="user.email"
          type="email"
          name="email"
        />
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            class="ml-auto mt-2"
            @click="save_changes"
            :disabled="!validateForm"
            >Save Changes</vs-button
          >
          <!-- <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Service from "../../../../services";

import vSelect from "vue-select";

export default {
  components: {
    vSelect
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      status: "inactive",
      role: "",
      statusOptions: ["active", "inactive"],
      roleOptions: [
        "admin",
        "staff",
        "marketing",
        "accountant",
        "check-in-staff",
        "so-owner",
        "so-admin",
        "so-staff",
        "so-check-in-staf",
        "so-accountant"
      ]
    };
  },
  computed: {
    /*
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.role),
          value: this.data_local.role
        };
      },
      set(obj) {
        this.data_local.role = obj.value;
      }
    }
    */
    validateForm() {
      return true;
    }
  },
  created() {
    if (this.user.isactive) {
      this.status = "active";
    }

    let found = this.user.role.biz.ev.find(x => x.e == this.$route.query.e);
    this.role = found.role;
  },
  methods: {
    capitalize(str) {
      //return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    save_changes() {
      if (!this.validateForm) return;

      let data = {
        e: this.$route.query.e,
        s: this.$route.query.s
      };

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      let index = this.user.role.biz.ev.findIndex(
        x => x.e == this.$route.query.e
      );

      this.user.isactive = this.status;
      this.user.role.biz.ev[index].role = this.role;

      Service.User.update(this.user, params)
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success"
            });
          }
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
        });
    },

    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
    }
  }
};
</script>
